// @ts-check
import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from 'modules/queries/api';
import toast from '@liquidweb-dev/undercurrent/toast';
import useSnackbarError from 'utility/hooks/useSnackbarError';

export const useStatedataAdd = () => {
	const queryClient = useQueryClient();
	const snackbarError = useSnackbarError();

	return useMutation({
		mutationFn:
			/** @param {import('club-sauce/public/account/user/stateData/index.raw').LWApiPublicAccountUserStateDataAddParamsRawI} params */
			(params) => api.account.user.stateData.apiRaw.add(params),

		onMutate: async (params) => {
			await queryClient.cancelQueries({
				queryKey: ['/account/user/statedata/listforkey', { key: params.key }],
			});

			queryClient.setQueryData(
				['/account/user/statedata/listforkey', { key: params.key }],
				/** @param {import('club-sauce/public/account/user/stateData/index.raw').LWApiPublicAccountUserStateDataListForKeyResultRawI} current */
				(current) => {
					const data = JSON.parse(params.data);

					return {
						...current,
						data: [data, ...current.data],
					};
				},
			);
		},

		onSuccess: (data, params) => {
			queryClient.invalidateQueries({
				queryKey: ['/account/user/statedata/listforkey', { key: params.key }],
			});
		},

		onError: snackbarError,
	});
};

export const useAddFavorite = () => {
	const queryClient = useQueryClient();
	const snackbarError = useSnackbarError();

	return useMutation({
		mutationFn:
			/** @param {{path: string, displayName: string}} params */
			({ path, displayName }) =>
				api.account.user.stateData.apiRaw.add({
					key: 'favorites',
					data: JSON.stringify({ path, displayName }),
				}),

		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: ['/account/user/statedata/listforkey', { key: 'favorites' }],
			});

			toast.success('Added to favorites');
		},

		onError: snackbarError,
	});
};

export default useStatedataAdd;
